/* eslint-disable react/jsx-key */
/* eslint-disable array-callback-return */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';

const yearsList = [
    { title: '2026年', id: 'newList2026', chipId: 289362 },
    { title: '2025年', id: 'newList2025', chipId: 289361 },
    { title: '2024年', id: 'newList2024', chipId: 289360 },
    { title: '2023年', id: 'newList2023', chipId: 289359 },
    { title: '2022年', id: 'newList2022', chipId: 289358 },
    { title: '2021年', id: 'newList2021', chipId: 285147 },
    { title: '2020年', id: 'newList2020', chipId: 285132 },
    { title: '2019年', id: 'newList2019', chipId: 255939 },
    { title: '2018年', id: 'newList2018', chipId: 255940 },
    { title: '2017年', id: 'newList2017', chipId: 255941 },
    { title: '2016年', id: 'newList2016', chipId: 255942 },
    { title: '2015年', id: 'newList2015', chipId: 255943 },
    { title: '2014年', id: 'newList2014', chipId: 225822 },
    { title: '2013年', id: 'newList2013', chipId: 225823 },
    { title: '2012年', id: 'newList2012', chipId: 255944 },
    { title: '2011年', id: 'newList2011', chipId: 255945 },
    { title: '2010年', id: 'newList2010', chipId: 255946 },
    { title: '2009年', id: 'newList2009', chipId: 195915 },
    { title: '2008年', id: 'newList2008', chipId: 225824 },
    { title: '2007年', id: 'newList2007', chipId: 255947 },
    { title: '2006年', id: 'newList2006', chipId: 195916 },
    { title: '其他', id: 'newListAgo', chipId: 255948 },
];

class CorpNewsYears extends React.PureComponent {
    static propTypes = {
        onMouseMove: PropTypes.func,
    };

    render() {
        const { onMouseMove } = this.props;

        return (
            <div className={styles.record_txt}>
                <ul id="years">
                    {yearsList.map((item, index) => {
                        return (
                            <li key={index}>
                                <Chip id={item.chipId} type="recommend" title={item.title} groupName="年份内容">
                                    <a href="javascript:void(0);" onMouseMove={() => onMouseMove(item.id)}>
                                        {item.title}
                                    </a>
                                </Chip>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}

export default CorpNewsYears;
